export const getCardsInResults = (state) => {
  const cardIds = getCurrentActiveCardSet(state);
  if (!cardIds) return [];

  return cardIds.map((id) => state.cards.byId[id]);
};

export const getActiveActivityFilter = (state) => state.search.filters.activity;

export const getCurrentActiveCardSet = (state) => {
  const activity = getActiveActivityFilter(state);
  const baseSet = state.cards.searchIndexes.activity[activity] || [];

  let resultSet = [...baseSet];

  const applyStrictAndFilter = (filterValues, indexKey) => {
    if (!filterValues || filterValues.length === 0) return;

    // Start with first selected value
    let intersection = state.cards.searchIndexes[indexKey][filterValues[0]] || [];

    // Intersect with each additional selected value
    for (let i = 1; i < filterValues.length; i++) {
      const nextSet = state.cards.searchIndexes[indexKey][filterValues[i]] || [];

      intersection = intersection.filter((id) => nextSet.includes(id));
    }

    // Intersect with current resultSet
    resultSet = resultSet.filter((id) => intersection.includes(id));
  };

  const { playType, players, minutes, avoidMaterials } = state.search.filters;

  applyStrictAndFilter(playType, 'play_type');
  applyStrictAndFilter(players, 'players');
  applyStrictAndFilter(minutes, 'minutes');

  if (avoidMaterials) {
    resultSet = resultSet.filter((id) => {
      const card = state.cards.byId[id];
      return card?.search?.avoidMaterials;
    });
  }

  return resultSet;
};

export const getAvailableOptionsById = (state, id) => {
  const currentCardSet = getCurrentActiveCardSet(state);
  if (!currentCardSet) return [];

  if (id === 'avoidMaterials') {
    return currentCardSet.some((id) => {
      const card = state.cards.byId[id];
      return card?.search?.avoidMaterials;
    });
  }

  const optionCardSets = state.cards.searchIndexes[id] || {};
  const availableOptions = Object.keys(optionCardSets).filter((key) => {
    const intersect = currentCardSet.filter((id) => optionCardSets[key].includes(id));
    return intersect.length > 0;
  });

  return availableOptions;
};
